import { CountryCodeType } from '@bus/models';
import { AddressFormModel_OL } from './formModel';

export const getInitialValues = (isCountryIncluded: boolean): AddressFormModel_OL => {
  return {
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    eirCode: '',
    town: '',
    county: undefined,
    country: isCountryIncluded ? CountryCodeType.Ireland : undefined,
  };
};
